import React, { FC } from 'react';
import { Props } from './icon.types';

export const RefreshBtn: FC<Props> = ({ color, className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 16">
      <path stroke={color} strokeWidth={2} d="M15.0003 8.03874C15.0003 11.7206 12.0156 14.7054 8.33366 14.7054C4.65176 14.7054 2.33366 11.0387 2.33366 11.0387M1.66699 8.03874C1.66699 4.35684 4.62996 1.37207 8.33366 1.37207C12.7781 1.37207 15.0003 5.03874 15.0003 5.03874M15.0003 5.03874V2.7054M15.0003 5.03874H12.667M2.33366 11.0387H4.66699M2.33366 11.0387V13.3721" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};